/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  UtxWithdrawFiatGetWithdrawMethodParams,
  PostWithdrawFiatDTO
} from './schema'



/**
 * Get all withdraw fiat requirements
 */
export const utxWithdrawFiatGetWithdrawMethod = (
    params?: UtxWithdrawFiatGetWithdrawMethodParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/withdraw/fiat/method`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxWithdrawFiatGetWithdrawMethodQueryKey = (params?: UtxWithdrawFiatGetWithdrawMethodParams,) => [`/withdraw/fiat/method`, ...(params ? [params]: [])];

    
export type UtxWithdrawFiatGetWithdrawMethodQueryResult = NonNullable<Awaited<ReturnType<typeof utxWithdrawFiatGetWithdrawMethod>>>
export type UtxWithdrawFiatGetWithdrawMethodQueryError = AxiosError<unknown>

export const useUtxWithdrawFiatGetWithdrawMethod = <TData = Awaited<ReturnType<typeof utxWithdrawFiatGetWithdrawMethod>>, TError = AxiosError<unknown>>(
 params?: UtxWithdrawFiatGetWithdrawMethodParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxWithdrawFiatGetWithdrawMethod>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxWithdrawFiatGetWithdrawMethodQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxWithdrawFiatGetWithdrawMethod>>> = ({ signal }) => utxWithdrawFiatGetWithdrawMethod(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxWithdrawFiatGetWithdrawMethod>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Place fiat withdrawal request
 */
export const utxWithdrawFiatRequestFiatWithdrawal = (
    postWithdrawFiatDTO: PostWithdrawFiatDTO, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/withdraw/fiat`,
      postWithdrawFiatDTO,options
    );
  }



    export type UtxWithdrawFiatRequestFiatWithdrawalMutationResult = NonNullable<Awaited<ReturnType<typeof utxWithdrawFiatRequestFiatWithdrawal>>>
    export type UtxWithdrawFiatRequestFiatWithdrawalMutationBody = PostWithdrawFiatDTO
    export type UtxWithdrawFiatRequestFiatWithdrawalMutationError = AxiosError<unknown>

    export const useUtxWithdrawFiatRequestFiatWithdrawal = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxWithdrawFiatRequestFiatWithdrawal>>, TError,{data: PostWithdrawFiatDTO}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxWithdrawFiatRequestFiatWithdrawal>>, {data: PostWithdrawFiatDTO}> = (props) => {
          const {data} = props ?? {};

          return  utxWithdrawFiatRequestFiatWithdrawal(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxWithdrawFiatRequestFiatWithdrawal>>, TError, {data: PostWithdrawFiatDTO}, TContext>(mutationFn, mutationOptions)
    }
    